import {useEffect, useState} from 'react';
import {SOCIALS, TOP_SECTION} from '../../Module/General';
import cross from './assets/cross.svg';
import Dis from './assets/icons8-discord.svg';
import Facebook from './assets/icons8-facebook.svg';
import Insta from './assets/icons8-instagram.svg';
import Twitter from './assets/icons8-twitter.svg';
//------------------------------------------------------------------
import './style.scss';

const GithubTemplate = ({hideTemplate}) => {
  return (
    <div className="template">
      <div className="template-left">
        <p>
          ¡Únete a nuestro <a href={TOP_SECTION.DISCORD_LINK}>Discord</a> para
          ponerte en contacto con la comunidad Co-Afina 2023!
        </p>
      </div>
      <img onClick={hideTemplate} src={cross} />
    </div>
  );
};

const Footer = () => {
  const [template, setTemplate] = useState(false);
  const [viewTemplate, setViewTemplate] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);

    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
  }, []);

  const listenScrollEvent = e => {
    if (window.scrollY > 2800) setTemplate(true);
    else if (window.scrollY < 2800) setTemplate(false);
  };

  return (
    <div>
      <div className="footer">
        <div className="social-icons-container">
          <div className="social-icon">
            <a rel="noreferrer" target="_blank" href={SOCIALS.instagram}>
              <img src={Insta} alt="" />
            </a>
          </div>
          <div className="social-icon">
            <a rel="noreferrer" target="_blank" href={SOCIALS.twitter}>
              <img src={Twitter} alt="" />
            </a>
          </div>
          <div className="social-icon">
            <a rel="noreferrer" target="_blank" href={SOCIALS.facebook}>
              <img src={Facebook} alt="" />
            </a>
          </div>
          <div className="social-icon">
            <a rel="noreferrer" target="_blank" href={SOCIALS.discord}>
              <img src={Dis} alt="" />
            </a>
          </div>
        </div>
        {/*
        <div className="Register_a">

            
          <a href={TOP_SECTION.HACKERS_REGISTRATION_FORM_LINK}>
            <Btn type="Registro" overlay="Llena el formulario" />
          </a>
          
          {FOOTER.JOIN_TEAM.required && (
            <a href={FOOTER.JOIN_TEAM.src}>
              <Btn
                type="¿Quieres apoyar?"
                class="Volunteer"
                overlay="¡Escríbenos!"
              />
            </a>
          )}
        </div>
        */}

        <div className="footer_info">
          {/*
          <p>
            Contáctanos{' '}
            <a href={SOCIALS.email}>
              <em>{SOCIALS.mail}</em>
            </a>{' '}
          </p>
          {FOOTER.Privacy_policy.required && (
            <a
              href={PrivacyPolicy}
              download
              target="blank"
              className="privacy-policy"
            >
              <p>Política de privacidad</p>
            </a>
          )}
          {FOOTER.Terms_of_use.required && (
            <a
              href={TermsOfUse}
              download
              target="blank"
              className="privacy-policy"
            >
              <p>Términos de uso</p>
            </a>
          )}
          */}
          <p>Hecho con ❤️ Adaptado de Limbo-Hacks Hackathon template</p>
        </div>
        {template && viewTemplate && (
          <GithubTemplate hideTemplate={() => setViewTemplate(false)} />
        )}
      </div>
    </div>
  );
};

export default Footer;
